import React from 'react';
import moment from 'moment';
import CellText from '../CellText/CellText';
import CellDataContainer from '../CellDataContainer/CellDataContainer';
import styles from './RequestIdAndCreationDate.module.scss';
import { Rate, Tooltip } from 'antd';

const RequestIdAndCreationDate = ({ request = {}, showInLifeCirle }) => {
  const requestId = request.id || '-';
  const rating = request.rating || 0;
  const creationDate = request.createDateTime
    ? moment(request.createDateTime).format('DD.MM.YY HH:mm')
    : '-';

  return (
    <CellDataContainer>
      {showInLifeCirle && (
        <Tooltip title="Стадия помещения">
          <CellText className={styles.text}>
            {request.stageAddressLifeCycle?.name}
          </CellText>
        </Tooltip>
      )}
      <Tooltip title="Номер заявки">
        <CellText className={styles.text}>{requestId}</CellText>
      </Tooltip>
      <Tooltip title="Дата создания">
        <CellText className={styles.text}>{creationDate}</CellText>
      </Tooltip>
      <div className={styles.rate}>
        <Rate
          disabled
          style={{ fontSize: 12 }}
          defaultValue={Number(rating)}
        />
      </div>
    </CellDataContainer>
  );
};

export default RequestIdAndCreationDate;
